import type { JSX } from 'react'
import { useNavigate } from 'react-router'
import {
  Building2,
  // ChevronRight,
  LogOut,
  ShieldCheck,
  // Smartphone,
  User,
} from 'lucide-react'
import PageHeader from '../../components/admin/PageHeader.js'
import { useAuthStore } from '../../store/authStore.js'
import { logout } from '../../auth/logout.js'
import MfaSection from '../../components/agent/MfaSection.js'

export default function AgentProfilePage(): JSX.Element {
  const user = useAuthStore((s) => s.user)
  const navigate = useNavigate()

  async function handleSignOut(): Promise<void> {
    await logout()
    navigate('/login')
  }

  const displayName =
    user?.loginId || user?.fullName || user?.email || 'Agent'
  const avatarInitial = (displayName.charAt(0) || 'A').toUpperCase()

  return (
    <div className="min-h-full bg-[#F4F6F8] p-4">
      <PageHeader
        title="Profile"
        description="Your account"
        actions={
          <button
            type="button"
            onClick={() => void handleSignOut()}
            className="flex h-9 items-center gap-1.5 rounded-[3px] border border-red-200 bg-white px-4 text-[13px] font-semibold text-red-600 transition-colors hover:bg-red-50"
          >
            <LogOut className="h-4 w-4" />
            Sign Out
          </button>
        }
      />

      <div className="mt-6 space-y-3">
        <section className="rounded-[3px] border border-slate-200 bg-white p-5">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[3px] bg-blue-50 text-lg font-semibold text-[#3366FF]">
              {avatarInitial}
            </span>
            <div className="flex-1">
              <h2 className="text-[17px] font-bold leading-tight tracking-tight text-[#0f172a]">
                {displayName}
              </h2>
              <p className="mt-1 text-[12.5px] text-slate-500">
                {user?.email ?? '—'} • {user?.tenantSlug ?? '—'}
              </p>
            </div>
          </div>

          <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-3">
            <div className="rounded-[3px] bg-slate-50 p-3">
              <div className="mb-1 flex items-center gap-2 text-[12.5px] font-medium text-slate-500">
                <Building2 className="h-4 w-4 text-[#3366FF]" />
                Tenant
              </div>
              <p className="text-sm font-semibold text-[#0f172a]">
                {user?.tenantSlug ?? '—'}
              </p>
            </div>
            <div className="rounded-[3px] bg-slate-50 p-3">
              <div className="mb-1 flex items-center gap-2 text-[12.5px] font-medium text-slate-500">
                <ShieldCheck className="h-4 w-4 text-[#3366FF]" />
                Roles
              </div>
              <p className="text-sm font-semibold text-[#0f172a]">
                {(user?.roles ?? []).join(', ') || '—'}
              </p>
            </div>
            <div className="rounded-[3px] bg-slate-50 p-3">
              <div className="mb-1 flex items-center gap-2 text-[12.5px] font-medium text-slate-500">
                <User className="h-4 w-4 text-[#3366FF]" />
                User ID
              </div>
              <p className="text-sm font-mono font-semibold text-[#0f172a]">
                {user?.sub ?? '—'}
              </p>
            </div>
          </div>
        </section>

        {/* <Link
          to="/agent/devices"
          className="group flex items-center justify-between rounded-[3px] border border-slate-200 bg-white p-5 transition-colors hover:border-slate-300"
        >
          <div className="flex items-center gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[3px] bg-blue-50 text-[#3366FF]">
              <Smartphone className="h-5 w-5" />
            </span>
            <div>
              <h3 className="text-[17px] font-bold leading-tight tracking-tight text-[#0f172a]">
                Devices
              </h3>
              <p className="mt-0.5 text-[12.5px] text-slate-500">
                Manage the SIP endpoints attached to your account.
              </p>
            </div>
          </div>
          <ChevronRight className="h-5 w-5 text-slate-400 transition-colors group-hover:text-[#3366FF]" />
        </Link> */}

        <MfaSection />
      </div>
    </div>
  )
}
